module.exports = __webpack_public_path__ + "img/bee-img-auth-sideimg5.ab25049e.png";